import styled from "styled-components";
import { Modal as Base } from "@sablier/v2-components/organisms";
import { useT } from "@sablier/v2-locales";
import { useModalLegend } from "~/client/hooks";
import Body from "./Body";

const Modal = styled(Base.Card)`
  div[data-component="modal-card"] {
    max-width: 500px;
  }
`;

function Legend() {
  const { id: modalId } = useModalLegend();
  const { t } = useT();

  return (
    <Modal id={modalId} title={t("modalCards.legend.title")}>
      <Body />
    </Modal>
  );
}

export default Legend;
